/**
 * Environment configuration for demo deployment (demo.sportowie.pl)
 */
export const environment = {
  production: false,
  runtimePlatform: 'web' as const,
  appVersion: '0.1.0',
  // Public/backoffice API host — used for non-tenant requests
  // For tenant requests, TenantService replaces hostname with window.location.hostname
  apiUrl: 'https://platform.demo.sportowie.pl',
  publicApiUrl: 'https://platform.demo.sportowie.pl',
  backofficeUrl: 'platform.demo.sportowie.pl',
  apiTimeout: 30000,
  retryAttempts: 2,
  retryDelay: 1000
};
